import {
  Hand, Radio, PhoneCall, Ambulance, Zap, ShieldCheck, Feather,
  BatteryCharging, Droplets, Lock, Headphones, UserCheck, Wrench,
  BadgeCheck, Phone, CalendarClock, CheckCircle2, Clock, MapPin,
  Mail, Menu, X, ChevronRight, Play, Pause, Star,
} from "lucide-react";

const MAP = {
  Hand, Radio, PhoneCall, Ambulance, Zap, ShieldCheck, Feather,
  BatteryCharging, Droplets, Lock, Headphones, UserCheck, Wrench,
  BadgeCheck, Phone, CalendarClock, CheckCircle2, Clock, MapPin,
  Mail, Menu, X, ChevronRight, Play, Pause, Star,
};

export default function Icon({ name, className, strokeWidth = 2 }) {
  const Cmp = MAP[name] || ShieldCheck;
  return <Cmp className={className} strokeWidth={strokeWidth} aria-hidden="true" />;
}
